import { Alert, Switch, Typography} from "antd";
import { LinkOutlined } from "@ant-design/icons";
import styles from "./permissionRow.module.scss";
const { Paragraph, Title } = Typography;

export const PermissionRow = ({
  permission,
  permissionById,
  on,
  unmet,
  broken,
  onToggle,
}) => {
  const nameOf = (id) => permissionById[id]?.name || id;
  const requires = permission.requires || [];

  return (
    <div className={styles.permissionRow}>
      <div className={styles.permissionRow__main}>
        <div className={styles.permissionRow__text}>
          <Title level={5} className={styles.permissionRow__name}>
            {permission.name}
          </Title>
          <Paragraph style={{ marginBottom: 3 }} className="text-secondary">
            {permission.desc}
          </Paragraph>

          {requires.length > 0 && (
            <Typography.Text className={styles.permissionRow__dep}>
              <LinkOutlined className={styles.permissionRow__depIcon} />
              <span>Requires: {requires.map(nameOf).join(", ")}</span>
            </Typography.Text>
          )}
        </div>

        <Switch checked={on} onChange={onToggle} />
      </div>

      {unmet.length > 0 && (
          <Alert
            className={styles.permissionRow__alert}
            type="warning"
            showIcon
            message={
              <>
                <span>{unmet.map((id) => `'${nameOf(id)}'`).join(", ")}</span>
                {unmet.length > 1
                  ? " are also needed for this permission to work."
                  : " is also needed for this permission to work."}
              </>
            }
          />
      )}

      {broken.length > 0 && (
          <Alert
            className={styles.permissionRow__alert}
            type="error"
            showIcon
            message={
              <>
                <span>{broken.map((id) => `'${nameOf(id)}'`).join(", ")}</span>
                {broken.length > 1 ? " require" : " requires"} this permission to work.
              </>
            }
          />
      )}
    </div>
  );
};
